
import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useParams, } from 'react-router-dom';
import Sidebar from '../Layouts/Sidebar';
import TopBar from '../Layouts/TopBar';
import instance from '../Config/AxiosConfig';
import { ToastContainer, toast } from 'react-toastify';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';

import { tns } from 'tiny-slider/src/tiny-slider';
import 'tiny-slider/dist/tiny-slider.css';
function Connection() {
    const { id } = useParams();

    const [enseignant, setEnseignant] = useState({});
    const [universityName, setUniversityName] = useState("");
    const [departmentName, setDepartmentName] = useState("");
    const [link, setLink] = useState("");
    const [documentNumbers, setDocumentNumbers] = useState([]);
    const [connectionsNumber, setConnectionsNumber] = useState([]);
    const [interests, setInterests] = useState([])
    const [connections, setConnections] = useState([]);
    const [projects, setProjects] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [numberDocuments, setNumberDocuments] = useState([]);
    const [projectsNumber, setProjectsNumber] = useState([]);

    useEffect(() => {


        axios.get(`https://go.vecos.us/reunice/API/v1/users/get/${id}`)
            .then(response => {

                setEnseignant(response.data);
                setUniversityName(response.data.universityName);
                setDepartmentName(response.data.departmentName);
                setLink(response.data.link);
                setConnectionsNumber(response.data.connectionsNumber);
                setDocumentNumbers(response.data.documentNumber);
                setConnections(response.data.connections);
                setInterests(response.data.interests);
                setProjects(response.data.projects);
                setDocuments(response.data.documents);
                const sortedDocuments = response.data.documents.sort((a, b) => new Date(b.publicationDate) - new Date(a.publicationDate));
                setDocuments(sortedDocuments);
                setNumberDocuments(response.data.numberDocuments);
                setProjectsNumber(response.data.projectsNumber);
            })

            .catch(error => {
                console.error('Erreur lors de la récupération des données:', error);
            });


    }, []);
    const [removeConnection, setRemoveConnection] = useState([])

    const handleRemoveConnection = (id) => {
        const token = Cookies.get('token')
        let data = new FormData();
        data.append('id', id);
        instance.post('/connectionsLists/remove', data, token)

            .then(response => {



                if (response.status === 200) {
                    setRemoveConnection(prevData => prevData?.filter(item => item.id !== id));
                    
                    toast.success('Successfully delete connection ', {
                        position: "top-right",
                        autoClose: 500,
                        hideProgressBar: false,

                    });

                }

            })
            .catch(error => {
                toast.error('Error delete connection!', {
                    position: "top-right",
                    autoClose: 500,
                    hideProgressBar: false,

                });
                console.error('Erreur lors de la suppression des données:', error);
            });

    };




    const [suggest, setSuggest] = useState([])

    useEffect(() => {
        const token = Cookies.get('token');

        instance.get('/users/suggest', token)
            .then(response => {
                setSuggest(response.data)
            })

            .catch(error => {
                console.error('Erreur lors de la récupération des données:', error);
            });


    }, []);


    const [invite, setInvite] = useState('')

    const handleInvit = async (id) => {

        const token = Cookies.get('token');

        let data = new FormData();
        data.append('id', id);
        data.append('message', 'message');

        try {

            const response = await instance.post('/connectionRequests/send', data, token)
            setInvite(response)


            if (response.status === 200) {
                Swal.fire({
                    position: "top-center",
                    icon: "success",
                    title: "Connection request sent successfully.",
                    showConfirmButton: false,
                    timer: 1500,
                    imageWidth: 200,
                    imageHeight: 200,
                });
                // const friendfiltred = suggest.filter(interest => !invite.includes(interest.id.toString()));
                // setAllInterest(Interestsfiltred);

            } else {
                alert("error")
            }

        }
        catch (error) {
            console.error('Erreur lors de la récupération des données:', error);
        }

    }

    useEffect(() => {


        if (invite) {
            const userxx = suggest?.map(prevuser => prevuser.id)
            console.log(userxx, 'userxxuserxxuserxx');
            const requestUser = userxx?.includes(id)

            requestUser?.filter(prevuser => prevuser.id !== id)
        }


    }, [])



    useEffect(() => {
        // Initialize Tiny Slider
        const slider = tns({
            container: '.my-slider',
            items: 3, // Number of items per slide
            slideBy: 'page',
            autoplay: false,
            nav: false,
            controls: true,

            autoplayButtonOutput: false,
            responsive: {
                0: {
                    items: 2 // Number of items shown on smaller screens
                },
                768: {
                    items: 3 // Number of items shown on medium screens
                },
                992: {
                    items: 4 // Number of items shown on larger screens
                }
            }
        });

        return () => {
            if (slider && slider.destroy) {
                slider.destroy();
            }
        };
    }, []);

    //when i sendrequest ,the friend has deleted of list of suggestions


    return (
        <>
            <TopBar />
            <main>
                <div class="container">
                    <div class="row g-4">
                        {/* Sidenav START */}
                        <div className="col-lg-3">
                            <Sidebar />
                        </div>
                        <div className="col-md-8 col-lg-9 vstack gap-4">


                            <div className="card">
                                {/* Card header START */}
                                <div className="card-header d-flex justify-content-between align-items-center border-0 pb-0">
                                    <h6 className="card-title mb-0">People you may know</h6>

                                </div>
                                {/* Card header START */}

                                <div className="container my-3">
                                    <div className="my-slider">
                                        {suggest && suggest.map((item, index) => (
                                            <div key={index} className="slider-item ">
                                                <div className="card shadow-none text-center ">
                                                    {/* Card body */}
                                                    <div className="card-body  p-2 pb-0">
                                                        <div className="avatar avatar-xl">
                                                            <img className="avatar-img rounded-circle" src={item.profilePicture} alt={`${item.firstName} ${item.lastName}`} />
                                                        </div>
                                                        <h6 className="card-title mb-1 mt-3"> <a href={"/profil/" + item.id}>{item.firstName} {item.lastName}</a></h6>
                                            
                                                    </div>
                                                    {/* Card footer */}
                                                    <div className="card-footer p-2 border-0">
                                                        <button className="btn btn-sm btn-primary-soft w-100 " onClick={() => handleInvit(item.id)}> Add friend </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                </div>


                            </div>

                            <div className="card">
                                {/* Card header START */}
                                <div className="card-header border-0 pb-0">
                                    <h5 className="card-title"> Connections</h5>
                                </div>
                                <div className="card-body">
                                    <ToastContainer style={{ marginTop: '30px', width: "max-content", }} />

                                    {connections.length !== 0 ?

                                        connections.map((item, index) => (
                                            <>

                                                <div key={index} className="d-md-flex align-items-center mb-4">

                                                    <div className="avatar avatar-story avatar-xl me-3 mb-3 mb-md-0">
                                                        <a href="#!"> <img className="avatar-img rounded-circle" src={item.profilePicture} alt={item.acronym} /> </a>
                                                    </div>

                                                    <div className="w-100">
                                                        <div className="d-sm-flex align-items-start">
                                                            <h6 className="mb-0"><a href={"/profil/" + item.id}>{item.firstName} {item.lastName}</a></h6>
                                                            <p className="small ms-sm-2 mb-0">{item.universityName} </p>
                                                        </div>
                                                    </div>

                                                    <div className="ms-md-auto d-flex">
                                                        <button className="btn btn-danger-soft btn-sm mb-0 me-2" onClick={() => handleRemoveConnection(item.id)}> Remove </button>
                                                        <button className="btn btn-primary-soft btn-sm mb-0"> Message </button>
                                                    </div>
                                                </div>
                                            </>



                                        ))
                                        :
                                        <>
                                            <div className="text-center">
                                                <i className="display-1 text-body-secondary bi bi-people"> </i>
                                                <h4 className="mt-2 mb-3 text-body">No connections founds</h4>
                                            </div>





                                        </>
                                    }




                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>



        </>
    )
}

export default Connection